import { render, staticRenderFns } from "./IconDropbox.vue?vue&type=template&id=543dcea6&"
import script from "./IconDropbox.vue?vue&type=script&lang=js&"
export * from "./IconDropbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543dcea6')) {
      api.createRecord('543dcea6', component.options)
    } else {
      api.reload('543dcea6', component.options)
    }
    module.hot.accept("./IconDropbox.vue?vue&type=template&id=543dcea6&", function () {
      api.rerender('543dcea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDropbox.vue"
export default component.exports